import React, { useState, useEffect, useContext } from 'react';
import { getUsers, ListCategoryClient, ListProject, createCategoryclient, updateCategoryClinet, ListClient, createTodo, updateTodo, getAllUsers } from '../../../../Utility/Api';
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../../../Utility/UserContext';
import MultiSelect from '../MultiSelect';
import { shop_id } from '../../../../Utility/function';

export const TodoForm = ({ openModal, setOpenModal, unit, closeModal, refreshList }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [users, setUsers] = useState([]);
  const [selectedManager, setSelectedManager] = useState([]);
  const [Category, setCategory] = useState([]);
  const [Project, setProject] = useState([]);
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

  useEffect(() => {
    fetchUsers();
    fetchCategory();
    fetchProject();
  }, []);

  const fetchProject = async () => {
    try {
      const response = await ListProject();
      if (response.data && response.data.data) {
        setProject(response.data.data);
        console.log("project", response.data.data)
      } else {
        toast.error('No units found.');
      }
    } catch (error) {
      console.error('Error fetching units:', error);
      toast.error('Error fetching units');
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await ListCategoryClient();
      if (response.data && response.data.data) {
        setCategory(response.data.data);

      } else {
        toast.error('No units found.');
      }
    } catch (error) {
      console.error('Error fetching units:', error);
      toast.error('Error fetching units');
    }
  };

  const fetchUsers = async (page = 1, text = "") => {
    try {
      const response = await getAllUsers(shopItem?.shop_id);
      if (response.data && response.data.data) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to fetch user data");
    }
  };

  const [Todo, setTodo] = useState({
    emp_id: "",
    project_id: "",
    category_id: "",
    title: "",
    description: "",
    status: "",
    from_date_time: "",
    to_date_time: "",
    estimated_hours: "",
    status: ""
  });

  useEffect(() => {
    console.log('selectedManager', selectedManager)
  }, [selectedManager])

  const [isScreenshotEnabled, setIsScreenshotEnabled] = useState(false);

  const handleSelectManager = (ID) => {
    setSelectedManager((prevState) => {
      if (prevState.includes(ID)) {
        return prevState.filter((item) => item !== ID);
      } else {
        return [...prevState, ID];
      }
    });
    console.log(ID);
  };

  const handleToggleChange = () => {
    setIsScreenshotEnabled((prevState) => !prevState);
    // Log the value as 1 or 0 based on the checkbox state
    const value = !isScreenshotEnabled ? "true" : "false";

    setTodo({
      ...Todo,
      is_billable: value,
    });
  };

  useEffect(() => {
    if (unit) {
      setTodo({
        emp_id: unit?.emp_id || "",
        project_id: unit?.project_id || "",
        category_id: unit?.category_id || "",
        title: unit?.title || "",
        description: unit?.description || "",
        status: unit?.status || "",
        from_date_time: unit?.from_date_time || "",
        to_date_time: unit?.to_date_time || "",
        estimated_hours: unit?.estimated_hours || ""
      });
      if (unit?.emp_id) {
        console.log(unit.emp_id.split(",").map(Number))
        setSelectedManager(unit.emp_id.split(",").map(Number))
      }
    }
  }, [unit]);

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };



  useEffect(() => {
    console.log('Todo', Todo)
  }, [Todo])

  const handleNext = () => {
    if (currentStep == 1) {
      const requiredFields = {
        title: "Title is required",
        description: "Description is required",
      };

      for (const [key, message] of Object.entries(requiredFields)) {
        if (!Todo[key]) {
          const toastId = `${key}-toast`; // unique per field
        
          if (!toast.isActive(toastId)) {
            toast.error(message, { toastId });
          }
        
          return;
        }
      }

    }

    if (currentStep == 2 && (!Todo.client_id || !Todo.start_date || !Todo.end_date || !Todo.is_billable)) {
      toast.error("All fields are required.");
      return;
    }

    setCurrentStep(currentStep + 1);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setTodo({
      ...Todo,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();


    const requiredFields = {
      project_id: "Project is required",
      category_id: "Category is required",
      from_date_time: "Start date is required",
      to_date_time: "End date is required",
      estimated_hours: "Estimated hours are required",
      status: "Status is required",
    };

    for (const [key, message] of Object.entries(requiredFields)) {
      if (!Todo[key]) {
        const toastId = `${key}-toast`; // unique toast ID per field
      
        if (!toast.isActive(toastId)) {
          toast.error(message, { toastId });
        }
      
        hideLoader(); // always hide loader even if toast already shown
        return;
      }
      
    }


    try {
      const updatedTodo = {
        ...Todo,
        emp_id: selectedManager.join(','),
        shop_id: shop_id
      };

      let response;

      if (unit) {
        await updateTodo(unit.todo_id, updatedTodo);
        toast.success('Project updated successfully');
      } else {
        response = await createTodo(updatedTodo);
        if (response) {
          toast.success('Todo added successfully');
        } else {
          throw new Error('Failed to add todo');
        }
      }
      closeModal();
      refreshList();
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'An unexpected error occurred');
    } finally {
      hideLoader();
    }
  };

  //modal-lg
  return (
    <div className={`modal fade ${openModal ? "show" : ""}`} style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog ">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: 'poppins' }}>
              {unit ? 'Edit Todo' : 'Add Todo'}
            </h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
          </div>
          <div className="modal-body" style={{ fontFamily: 'poppins' }}>
            <form className="">
              <div className="step-indicator mb-5 mt-3">
                <span className={`step ${currentStep === 1 ? 'active' : currentStep > 1 ? 'completed' : ''}`}>1</span>
                <span className={`step ${currentStep === 2 ? 'active' : currentStep > 2 ? 'completed' : ''}`}>2</span>
              </div>

              {currentStep === 1 && (
                <>
                  <div className="form-group mb-3">
                    <label htmlFor="title" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}
                    >Title :</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder='Enter title'
                      id="title"
                      name="title"
                      style={{ fontSize: 14 }}
                      value={Todo.title}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className={`form-group mb-3`}>
                    <label htmlFor="Description" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Description :</label>
                    <textarea
                      className="form-control"
                      placeholder='Enter Description'
                      id="description"
                      name="description"
                      value={Todo.description}
                      onChange={handleInputChange}
                      style={{ height: "100px", fontSize: 14 }}
                    />
                  </div>

                  <div className={`form-group row mb-5`}>
                    <label htmlFor="employee" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Employee :</label>
                    <MultiSelect
                      title={
                        selectedManager.length > 0
                          ? users
                            .filter(employee => selectedManager.includes(employee.user_Id))
                            .map(employee => employee.full_name)
                            .join(", ")
                          : 'Select Team Member'
                      }
                      options={users}
                      selectedValues={selectedManager}
                      onChange={handleSelectManager}
                      search={true}
                    />
                  </div>
                </>
              )}

              {false && (
                <>
                  {/* Client Name, Start Date, End Date, Hourly Rate, and Is Billable */}

                  <div className={`form-group row`}>
                    <div className={`form-group col-md-6`}>
                      <label htmlFor="client_id" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Client Name:</label>
                      <select
                        className="form-control"
                        id="client_id"
                        name="client_id"
                        value={Todo.client_id}
                        onChange={handleInputChange}
                        style={{ fontSize: 14 }}
                      >
                        <option disabled selected value="" >
                          Select Client
                        </option>
                        {/* {clients.map((client) => (
                      <option value={client.id} key={client.id}>
                        {client.first_name} {client.last_name}
                      </option>
                    ))} */}
                      </select>
                    </div>
                  </div>

                  <div className="form-group row">
                    <div
                      className={`form-group col-md-6 align-items-center d-flex align-items-center`}
                    >
                      <label
                        htmlFor="screenshotToggle"
                        className="col-form-label mr-2" style={{ fontSize: 14 }}
                      >
                        Is Billable:
                      </label>
                      <label className="switch mb-0">
                        <input
                          type="checkbox"
                          checked={isScreenshotEnabled}
                          onChange={handleToggleChange}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>

                  <div className={`form-group row`}>
                    <div className="form-group col-md-6">
                      <label htmlFor="start_date" style={{ fontSize: 14 }}>Start Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        id="start_date"
                        name="start_date"
                        style={{ fontSize: 14 }}
                        value={Todo.start_date}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="end_date" style={{ fontSize: 14 }}>End Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        id="end_date"
                        name="end_date"
                        style={{ fontSize: 14 }}
                        value={Todo.end_date}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                </>
              )}

              {currentStep === 2 && (
                <>

                  <div className={`form-group mb-3`}>
                    <label htmlFor="project_id" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Project:</label>
                    <select
                      className="form-control"
                      id="project_id"
                      name="project_id"
                      value={Todo.Project}
                      onChange={handleInputChange}
                      style={{ fontSize: 14 }}
                    >
                      <option disabled selected value="" >
                        Select Project
                      </option>

                      {Project.map((Projec) => (
                        <option value={Projec.id} key={Projec.id}>
                          {Projec.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className={`form-group mb-3`}>
                    <label htmlFor="hourly_rate" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Category:</label>
                    <select
                      className="form-control"
                      id="category_id"
                      name="category_id"
                      value={Todo.category_id}
                      onChange={handleInputChange}
                      style={{ fontSize: 14 }}
                    >
                      <option disabled selected value="" >
                        Select Category
                      </option>

                      {Category.map((Cat) => (
                        <option value={Cat.id} key={Cat.id}>
                          {Cat.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className={`form-group mb-3`}>
                    <label htmlFor="total_hours" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Start Date :</label>
                    <input
                      type="date"
                      className="form-control"
                      id="from_date_time"
                      placeholder='Enter TotalHours'
                      name="from_date_time"
                      style={{ fontSize: 14 }}
                      value={Todo.from_date_time}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className={`form-group mb-3`}>
                    <label htmlFor="total_cost" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>End Date :</label>
                    <input
                      type="date"
                      className="form-control"
                      id="to_date_time"
                      placeholder='Enter End date'
                      name="to_date_time"
                      style={{ fontSize: 14 }}
                      value={Todo.to_date_time}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className={`form-group mb-3`}>
                    <label htmlFor="estimated_hours" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Estimated Hours :</label>
                    <input
                      type="text"
                      className="form-control"
                      id="estimated_hours"
                      placeholder='Enter Estimated Hours'
                      name="estimated_hours"
                      style={{ fontSize: 14 }}
                      value={Todo.estimated_hours}
                      onChange={handleInputChange}
                    />

                  </div>

                  <div className={`form-group mb-3`}>
                    <label htmlFor="estimated_hours" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>Status:</label>
                    <select
                      className="form-control"
                      id="status"
                      name="status"
                      value={Todo.status}
                      onChange={handleInputChange}
                      style={{ fontSize: 14 }}
                    >
                      <option disabled selected value="" >
                        Select Status
                      </option>
                      <option value="active" key='active'>
                        Active
                      </option>
                      <option value="inactive" key='inactive'>
                        In Active
                      </option>

                    </select>


                  </div>

                </>
              )}

            </form>
          </div>

          <div className="modal-footer">
            {currentStep == 1 && (
              <button type="button" className="btn btn-secondary" onClick={() => setOpenModal(false)}>
                close
              </button>
            )}
            {currentStep > 1 && (
              <button type="button" className="btn btn-secondary" onClick={handlePrevious}>
                Previous
              </button>
            )}
            {currentStep < 2 && (
              <button type="button" className="btn btn-primary" onClick={handleNext}>
                Continue
              </button>
            )}
            {currentStep === 2 && (
              <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                Add Todo
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};





export const ClientForm = ({ openModal, setOpenModal, unit, closeModal, refreshList }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [users, setUsers] = useState([]);
  const [selectedManager, setSelectedManager] = useState([]);
  const [SelectedTeams, setSelectedTeams] = useState([]);
  const [Client, setClient] = useState([]);
  const [Project, setProject] = useState([]);
  const [imagePreview, setImagePreview] = useState(null); // Store the preview URL


  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

  useEffect(() => {
    fetchUsers();
    fetchClient();
    fetchProject();
  }, []);


  const Filterusers = users.filter(user => user.role_title == "Manager");





  const fetchProject = async () => {
    try {
      const response = await ListProject();
      if (response.data && response.data.data) {
        setProject(response.data.data);
        console.log("project", response.data.data)
      } else {
        toast.error('No units found.');
      }
    } catch (error) {
      console.error('Error fetching units:', error);
      toast.error('Error fetching units');
    }
  };




  const fetchClient = async () => {
    try {
      const response = await ListClient();
      if (response.data && response.data.data) {
        setClient(response.data.data);
        console.log("project", response.data.data)
      } else {
        toast.error('No units found.');
      }
    } catch (error) {
      console.error('Error fetching units:', error);
      toast.error('Error fetching units');
    }
  };


  const fetchUsers = async (page = 1, text = "") => {
    try {
      const response = await getUsers(page, text, shopItem.shop_id);
      if (response.data && response.data.data) {
        setUsers(response.data.data);
        // setTotalPages(response.data.pagination.total_pages);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to fetch user data");
    }
  };

  const [Title, setTitle] = useState("");
  const [Icone, setIcone] = useState(null);
  const [errors, setErrors] = useState({});

  const [isScreenshotEnabled, setIsScreenshotEnabled] = useState(false);



  const handleSelectManager = (ID) => {
    setSelectedManager((prevState) => {
      if (prevState.includes(ID)) {
        return prevState.filter((item) => item !== ID);
      } else {
        return [...prevState, ID];
      }
    });
    console.log(ID);
  };


  const handleSelectTeams = (ID) => {
    setSelectedTeams((prevState) => {
      if (prevState.includes(ID)) {
        return prevState.filter((item) => item !== ID);
      } else {
        return [...prevState, ID];
      }
    });
    console.log(ID);
  };

  const [allMember, setAllmember] = useState(false);




  useEffect(() => {
    if (unit) {
      setTitle(unit.title);
      setIcone(unit.icon);
    }
  }, [unit]);


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "title") {
      setTitle(value);
    } else if (name === "icone") {
      const file = files[0];
      setIcone(file); // Handling file input
      setImagePreview(URL.createObjectURL(file));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!Title) {
    //   toast.error('Title is required');
    //   return;
    // }

    if (!Title) {
      if (!toast.isActive("title-toast")) {
        toast.error("Title is required", { toastId: "title-toast" });
      }
      return;
    }
  
    const FormDataAll = new FormData();
    FormDataAll.append("title", Title);
    if (Icone instanceof File || Icone instanceof Blob) {
      FormDataAll.append("icon", Icone);
    }
    showLoader();

    try {
      if (unit) {
        await updateCategoryClinet(unit.id, FormDataAll);
        toast.success('Category updated successfully');
      } else {
        const response = await createCategoryclient(FormDataAll);
        if (response) {
          toast.success('Category added successfully');
        } else {
          throw new Error('Failed to add project');
        }
      }
      closeModal();
      refreshList();
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || "Error saving product");
      } else {
        toast.error("Error saving data");
      }
    } finally {
      hideLoader();
    }
  };


  return (
    <div
      className={`modal fade ${openModal ? "show" : ""}`}
      style={{ display: 'block' }}
      tabIndex="-1"
      role="dialog">
      <div className="modal-dialog ">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: 'Poppins' }}>
              {unit ? 'Edit Category' : 'Add Category'}
            </h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
          </div>

          <div className="modal-body" style={{ fontFamily: 'Poppins' }}>
            <form>
              <div className="form-group mb-3">
                <label htmlFor="title" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>
                  Title:
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Title"
                  id="title"
                  name="title"
                  style={{ fontSize: 14 }}
                  value={Title}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mb-3 ">
                <label htmlFor="icone" style={{ fontSize: 15, fontWeight: 'bold', color: '#495057' }}>
                  Icone:
                </label>

                <input
                  type="file"
                  className="form-control"
                  id="icone"
                  name="icone"
                  style={{ fontSize: 14 }}
                  onChange={handleChange}  // No value prop for file input
                />


                {imagePreview ? (
                  <img src={imagePreview} style={{ width: "20%" }} className="mt-2" alt="Preview" />
                ) : unit && Icone ? (
                  <img src={`http://193.203.162.101:8002/${Icone}`} style={{ width: "20%" }} className="mt-2" alt="Icone" />
                ) : null}

              </div>
            </form>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={() => setOpenModal(false)}>
              Close
            </button>
            <button type="button" className="btn btn-success" onClick={handleSubmit}>
              {unit ? "Update Category" : "Add Category"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

